try {

      // Attribution capture — runs immediately on every page.
      // Reads gclid/UTM/etc from the URL; persists first-touch + latest-touch
      // to localStorage so the form-submit handler can attach them to the
      // lead record. First-touch never overwrites; latest-touch always does.
      //
      // Why both: first-touch is what Google Ads attributes the eventual
      // conversion to. Latest-touch is what GA4 attributes by default and
      // is useful when a user revisits via a different channel.
      //
      // This list SELECTS — anything not named here survives in location.search
      // but is never persisted, so it must stay in sync with the Google Ads
      // Final URL suffix (web/src/features/ranker/adgroups/exportPlanCsv.ts,
      // `finalUrlSuffix`) and with AttributionPayload in functions/api/lead.ts.
      // The trailing group is Google ValueTrack, substituted at click time:
      // network = g|s|d (Google search / search partner / Display),
      // matchtype = e|p|b|a, device = m|t|c.
      //
      // loc_physical_ms / loc_interest_ms are Google's own location ids for the
      // click (a criterion id from its geo target table: a city, a ZIP code, a
      // county, whichever it resolved): where the visitor was, and the place
      // the search was about. Recorded and nothing else; no page reads them.
      // `loc` is still the campaign's metro and still picks the phone number.
      //
      // The three Functions that carry a touch onward each keep their own copy
      // of this list (number-impression.ts and landing-event.ts filter by it,
      // lead.ts types it). attribution-fields-lockstep.test.mjs holds them to
      // this one, because a field missing there is dropped without a sound.
      (function () {
        try {
          var params = new URLSearchParams(location.search);
          var fields = [
            'gclid', 'gbraid', 'wbraid',
            'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
            'msclkid', 'fbclid',
            'loc',
            'network', 'matchtype', 'device', 'campaignid', 'adgroupid',
            'loc_physical_ms', 'loc_interest_ms',
          ];
          var captured = {};
          for (var i = 0; i < fields.length; i++) {
            var v = params.get(fields[i]);
            if (v) captured[fields[i]] = v;
          }
          if (Object.keys(captured).length === 0) return;
          captured._ts = new Date().toISOString();
          captured._landing = location.pathname;
          captured._referrer = document.referrer || null;
          if (!localStorage.getItem('attribution_first')) {
            localStorage.setItem('attribution_first', JSON.stringify(captured));
          }
          localStorage.setItem('attribution_latest', JSON.stringify(captured));
        } catch (_) {}
      })();
    
} catch (e) {
  setTimeout(function () { throw e; });
}
try {

      (function () {
        var FIELDS = ['gclid', 'gbraid', 'wbraid'];

        // First-touch wins: that is the click Google Ads attributes the eventual
        // conversion to. Latest-touch is the fallback, and the live URL is the
        // last resort (a visitor who landed with ?gclid= and has localStorage
        // blocked still gets attributed).
        function source() {
          var out = {};
          try {
            var stored =
              JSON.parse(localStorage.getItem('attribution_first') || 'null') ||
              JSON.parse(localStorage.getItem('attribution_latest') || 'null');
            if (stored) out = stored;
          } catch (_) {}
          var live = new URLSearchParams(location.search);
          for (var i = 0; i < FIELDS.length; i++) {
            if (!out[FIELDS[i]] && live.get(FIELDS[i])) out[FIELDS[i]] = live.get(FIELDS[i]);
          }
          return out;
        }

        // Metro the visitor was shown, resolved with the SAME precedence the
        // number-swap script below uses (?loc → sessionStorage → baked default),
        // so the room records the city the visitor actually saw a number for.
        function locSlug() {
          var fromUrl = new URLSearchParams(location.search).get('loc');
          if (fromUrl) return fromUrl.toLowerCase();
          try {
            var ctx = sessionStorage.getItem('loc_ctx');
            if (ctx) return ctx;
          } catch (_) {}
          return document.documentElement.dataset.locDefault || null;
        }

        // Same key, same read-or-mint shape as `bankVisitorKey()` further down
        // this file — duplicated rather than shared, because that one lives in
        // a separate closure and is deliberately deferred behind the
        // interaction gate for INP, so it would not exist yet on a visitor's
        // very first tap of a call-room CTA. Idempotent (same localStorage key),
        // so two closures minting it is harmless.
        //
        // A browser that will not keep one gets a code for THIS page instead
        // (`window.__lpVisitCode`, shared with `bankVisitorKey()`). The call
        // room's door ignores a link that carries no code at all, because that
        // is what a crawler following the link looks like, and a seller whose
        // browser blocks storage must not be mistaken for one.
        function visitorKey() {
          try {
            // The page's own copy second: a browser can accept a write and
            // keep nothing, and the link and the beacon must still agree.
            var k = localStorage.getItem('lp_visitor') || window.__lpVisitCode;
            if (!k) k = Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
            window.__lpVisitCode = k;
            localStorage.setItem('lp_visitor', k);
            return k;
          } catch (_) {
            if (!window.__lpVisitCode) {
              window.__lpVisitCode =
                Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
            }
            return window.__lpVisitCode;
          }
        }

        function decorate() {
          // Two kinds of target, decorated identically and differing only in
          // where the finished URL is written:
          //   [data-call-room]       — an ordinary link; the URL becomes `href`.
          //   [data-call-room-after] — a link whose `href` is already spoken for
          //                            (the header phone button, whose href must
          //                            stay `tel:` so the OS call sheet opens).
          //                            The URL is written back into the same
          //                            attribute for a click handler to use.
          var links = document.querySelectorAll(
            'a[data-call-room], a[data-call-room-after]'
          );
          if (!links.length) return;
          var attr = source();
          var loc = locSlug();

          for (var i = 0; i < links.length; i++) {
            var a = links[i];
            var after = a.hasAttribute('data-call-room-after');
            // The build-time value is the base (`…/start?b=<brand>`); rebuild
            // from it each time so repeated runs never stack duplicate params.
            var base =
              a.getAttribute('data-call-room-base') ||
              (after ? a.getAttribute('data-call-room-after') : a.getAttribute('href'));
            if (!base) continue;
            a.setAttribute('data-call-room-base', base);

            var url;
            try { url = new URL(base, location.href); } catch (_) { continue; }
            for (var f = 0; f < FIELDS.length; f++) {
              if (attr[FIELDS[f]]) url.searchParams.set(FIELDS[f], attr[FIELDS[f]]);
            }
            if (attr.utm_campaign) url.searchParams.set('campaign', attr.utm_campaign);
            // Carried so a room conversion stays reportable by city even when no
            // click id survives to make it uploadable.
            if (loc) url.searchParams.set('loc', loc);
            // Lets CallRoomController converge this anonymous "Talk now" click
            // onto the same deal the landing beacon already resolved for this
            // browser (`"web:" + visitor_key`), instead of minting a rival one
            // keyed on the brand-new room id it's about to create.
            var vk = visitorKey();
            if (vk) url.searchParams.set('visitor_key', vk);
            url.searchParams.set('path', location.pathname);
            a.setAttribute(after ? 'data-call-room-after' : 'href', url.toString());
          }
        }

        // The header phone button does TWO things on one tap: it hands the
        // number to the OS (its `href` is `tel:`, so Safari offers FaceTime,
        // Android opens the dialer) and it moves this page to the call room, so
        // that when the caller dismisses the OS sheet — or hangs up — they are
        // looking at the questions that make their offer better instead of the
        // page they just left.
        //
        // The navigation is deferred rather than immediate: navigating in the
        // same tick as a `tel:` activation cancels the call on some browsers.
        // 900ms is past the point where the OS has taken the URL and before
        // anyone has finished reading the sheet. `default` is never prevented —
        // if this script is broken or blocked, the tap is still just a phone
        // call, which is the behaviour that must never regress.
        document.addEventListener('click', function (e) {
          var a = e.target && e.target.closest && e.target.closest('a[data-call-room-after]');
          if (!a) return;
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
          var target = a.getAttribute('data-call-room-after');
          if (!target) return;
          setTimeout(function () {
            window.location.assign(target);
          }, 900);
        });

        function ready(fn) {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
          } else {
            fn();
          }
        }
        ready(decorate);
        window.addEventListener('pageshow', decorate);

        // The CTA click is the LAST moment this visitor is on the tracked domain
        // with a clean first-party Ads cookie, so it is the best-attributed
        // signal available for room traffic. Observe-only by design (secondary,
        // $5 in the ladder): the conversions that count happen in the room.
        // Delegated so it also covers CTAs added after this runs.
        //
        // BOTH selectors, because there are two doors into the room and they
        // carry different attributes (see decorate() above): the web-call CTA is
        // a plain `data-call-room` link, while the header phone button is
        // `data-call-room-after` — its `href` has to stay `tel:`, so its room URL
        // lives in the attribute and the handler above navigates to it ~900ms
        // later. Matching only the first left every phone-button entry into the
        // room unreported, which made call_room_click look like a fraction of
        // real room traffic.
        var roomClickFired = false;
        document.addEventListener('click', function (e) {
          var a = e.target && e.target.closest &&
            e.target.closest('a[data-call-room], a[data-call-room-after]');
          if (!a) return;
          // One report per page load, across both doors. A visitor who taps the
          // phone button and then the web-call CTA entered the room once, and
          // this counts entries, not taps. __fireConversion dedupes the Ads ping
          // on its own (convFired) but not the GA4 event, so without this guard
          // GA4 would double-count exactly the visitor this change starts
          // covering. Reset on a fresh page load, which is the same scope as
          // every other per-load dedupe on this page.
          if (roomClickFired) return;
          roomClickFired = true;
          if (window.__fireConversion) {
            // value omitted — inherits leadValueMap['call_room_click'] from config.
            window.__fireConversion('call_room_click', { currency: 'USD' });
          }
        });
      })();
    
} catch (e) {
  setTimeout(function () { throw e; });
}
try {

      (function () {
        if (!('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches)
          return;
        var targets = document.querySelectorAll(
          // Rail pages nest their sections one level down; home and the legal
          // pages keep them as direct children of main. Both shapes reveal.
          'main > section:not(.hero) > .container, .page-rail__body > section:not(.hero) > .container'
        );
        if (!targets.length) return;
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                e.target.classList.remove('reveal-hidden');
                e.target.classList.add('reveal-shown');
                io.unobserve(e.target);
              }
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
        );
        targets.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          var inView = rect.top < window.innerHeight && rect.bottom > 0;
          if (inView) return;
          el.classList.add('reveal-hidden');
          io.observe(el);
        });
      })();
    
} catch (e) {
  setTimeout(function () { throw e; });
}
try {

      // Offer buttons ([data-offer-focus]) anchor to the on-page form. The
      // enhancement: when #offer really is on this page, land the visitor
      // TYPING — scroll the form into view and focus its first field (inside a
      // click handler, so mobile keyboards are allowed to open). Any failure
      // falls back to the anchor's own navigation.
      (function () {
        document.addEventListener('click', function (e) {
          var a = e.target && e.target.closest && e.target.closest('[data-offer-focus]');
          if (!a) return;
          try {
            var form = document.getElementById('offer');
            if (!form) return; // off-form page: let /#offer navigate
            e.preventDefault();
            // Below the rail breakpoint the form is a fixed off-canvas drawer,
            // so there is nothing to scroll to — scrollIntoView on a
            // `position: fixed` element is a no-op and the button would look
            // broken. Hand the click to the drawer instead; it focuses the
            // first field itself, which is the same landing the scroll path
            // below is trying to produce. RailForm.astro publishes this.
            var drawer = window.__railDrawer;
            if (drawer && drawer.isActive()) {
              drawer.open();
              return;
            }
            // Skip the scroll when the form is already comfortably on screen
            // (the sticky rail at desktop): jumping a visible form to the top
            // is exactly the lost-your-place move these buttons exist to avoid.
            var r = form.getBoundingClientRect();
            if (r.top < 0 || r.top > window.innerHeight * 0.6) {
              form.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            // First VISIBLE focusable field. tabindex="-1" excludes the
            // honeypot (focusing it would flag the seller's own submission as
            // a bot's); the offsetParent check skips fields on a step that
            // isn't currently shown.
            var fields = form.querySelectorAll(
              'input:not([type="hidden"]):not([disabled]):not([tabindex="-1"]), select:not([disabled]), textarea:not([disabled])'
            );
            for (var i = 0; i < fields.length; i++) {
              if (fields[i].offsetParent !== null) {
                fields[i].focus({ preventScroll: true });
                break;
              }
            }
          } catch (err) {
            /* anchor default stands */
          }
        });
      })();
    
} catch (e) {
  setTimeout(function () { throw e; });
}
try {
(function(){const brandId = "testing";
const prodDomain = "eqall.net";
const defaultPhoneHref = "tel:+12148388869";

      // Location-number swap — shows a location-specific phone number when the
      // visitor arrived with a ?loc=<slug> (Google Ads Final URL suffix), a
      // remembered session location, or a city page's baked default.
      //
      // Zero CWV impact by design: the page renders the brand default number;
      // the lookup is same-origin, deferred off the critical path, and the
      // replacement strings are equal-length NANP "(xxx) xxx-xxxx" so no
      // layout shift. Any failure is silent — brand default stands.
      (function () {
        try {
          var LOC_RE = /^[a-z0-9]+(-[a-z0-9]+)*$/;
          function validLoc(s) {
            return typeof s === 'string' && s.length > 0 && s.length <= 64 && LOC_RE.test(s);
          }

          // Resolve the location: ?loc → sessionStorage → baked city → abort.
          var loc = null;
          var fromUrl = new URLSearchParams(location.search).get('loc');
          if (fromUrl) {
            fromUrl = fromUrl.toLowerCase();
            if (validLoc(fromUrl)) {
              loc = fromUrl;
              try { sessionStorage.setItem('loc_ctx', loc); } catch (_) {}
            }
          }
          if (!loc) {
            try {
              var ctx = sessionStorage.getItem('loc_ctx');
              if (validLoc(ctx)) loc = ctx;
            } catch (_) {}
          }
          if (!loc) {
            var baked = document.documentElement.dataset.locDefault;
            if (validLoc(baked)) loc = baked;
          }

          // Production-host gate — same rule as the tracking block below. An
          // impression written from localhost or a *.pages.dev preview would
          // put a bogus (number, click) pair in the real attribution table and
          // could mis-stitch a genuine call. A brand JSON without `domain`
          // fails OPEN, matching the tracking gate's behavior.
          var isProdHost = !prodDomain ||
            location.hostname === prodDomain ||
            location.hostname.slice(-(prodDomain.length + 1)) === '.' + prodDomain;

          // Per-tab id, used ONLY to collapse repeat beacons into one row
          // server-side. Not a user id: it dies with the tab, is never joined
          // to a person, and is never sent anywhere but our own origin.
          function sessionKey() {
            try {
              var k = sessionStorage.getItem('imp_session');
              if (!k) {
                k = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
                sessionStorage.setItem('imp_session', k);
              }
              return k;
            } catch (_) { return null; }
          }

          // Tell the server which number this visitor was shown, so an inbound
          // call to it can be matched back to the ad click. The click id lives
          // only in this browser's localStorage, and /api/number is edge- AND
          // session-cached, so without this beacon a caller is unattributable.
          //
          // Cheap by construction: only fires when a click id is actually
          // present (organic traffic never beacons), and at most once per 10
          // minutes per (tab, number).
          function beacon(n) {
            if (!isProdHost) return;
            try {
              var first = JSON.parse(localStorage.getItem('attribution_first') || 'null');
              var latest = JSON.parse(localStorage.getItem('attribution_latest') || 'null');
              var hasClick = function (a) {
                return a && (a.gclid || a.gbraid || a.wbraid);
              };
              if (!hasClick(first) && !hasClick(latest)) return;

              var throttleKey = 'imp_sent:' + n.phone_e164;
              var last = 0;
              try { last = parseInt(sessionStorage.getItem(throttleKey) || '0', 10) || 0; } catch (_) {}
              if (Date.now() - last < 600000) return;
              try { sessionStorage.setItem(throttleKey, String(Date.now())); } catch (_) {}

              fetch('/api/number-impression', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  phone_e164: n.phone_e164,
                  loc: n.loc,
                  session_key: sessionKey(),
                  attribution: { first: first, latest: latest },
                  path: location.pathname,
                }),
                // Survives the navigation when the visitor taps the number and
                // the tab is torn down — the exact case we most need recorded.
                keepalive: true,
              }).catch(function () {});
            } catch (_) {}
          }

          function apply(n) {
            var i, nodes;
            nodes = document.querySelectorAll('[data-phone-display]');
            for (i = 0; i < nodes.length; i++) nodes[i].textContent = n.phone_display;
            nodes = document.querySelectorAll('[data-phone-href]');
            for (i = 0; i < nodes.length; i++) nodes[i].setAttribute('href', 'tel:' + n.phone_e164);
            nodes = document.querySelectorAll('[data-phone-aria]');
            for (i = 0; i < nodes.length; i++) nodes[i].setAttribute('aria-label', 'Call ' + n.phone_display);
            // Record what this visitor saw, for the lead payload
            // (presented_number) — sessionStorage survives navigations.
            window.__locNumber = n;
            try { sessionStorage.setItem('shown_number', JSON.stringify(n)); } catch (_) {}
            // Off the critical path: the swap has already painted.
            if ('requestIdleCallback' in window) {
              requestIdleCallback(function () { beacon(n); }, { timeout: 3000 });
            } else {
              setTimeout(function () { beacon(n); }, 0);
            }
          }

          // THE DEFAULT-NUMBER IMPRESSION. The normal deployment is ONE shared
          // pipeline number, with a location-specific number only where one has
          // been deliberately attached — so on most pages no swap ever happens
          // and the visitor calls the number baked into the markup. Beaconing
          // only from apply() would record nothing at all on exactly that
          // common setup, which is why the impressions table stayed empty.
          //
          // The metro rides along from the page's own ?loc= rather than from
          // the number, so a single shared number still yields per-metro
          // reporting (the server keeps the claim unless a mapping contradicts
          // it, and a call only inherits a metro its impressions agree on).
          //
          // Deferred ~1.5s and skipped once a swap has landed, so a page that
          // DOES swap records the number actually shown rather than both. A
          // rare double-record is harmless: the two numbers are different rows
          // and a call matches whichever it actually dialed.
          var defaultE164 = String(defaultPhoneHref || '').replace(/^tel:/, '').trim();
          if (defaultE164) {
            setTimeout(function () {
              if (window.__locNumber) return;
              beacon({ phone_e164: defaultE164, loc: loc });
            }, 1500);
          }

          // No early return on a missing location any more. The endpoint now
          // answers without one, falling back to the BUSINESS UNIT's default
          // number — so the home page and category roots stop showing whatever
          // was baked into the brand file and start showing the unit's own
          // number, changeable in Brand Config without a rebuild. A location, if
          // present, still wins.

          // Per-(brand, loc) cache: {d: display, e: e164, none: true, exp: ms}.
          // 10-minute TTL, positive AND negative — ≤1 fetch per session.
          var cacheKey = 'loc_number:' + brandId + ':' + (loc || '_default');
          try {
            var cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
            if (cached && cached.exp > Date.now()) {
              if (!cached.none && cached.d && cached.e) {
                apply({ loc: loc, phone_display: cached.d, phone_e164: cached.e });
              }
              return;
            }
          } catch (_) {}

          function lookup() {
            try {
              fetch(
                '/api/number?brand=' + encodeURIComponent(brandId) +
                  (loc ? '&loc=' + encodeURIComponent(loc) : ''),
                {
                  signal: typeof AbortSignal !== 'undefined' && AbortSignal.timeout
                    ? AbortSignal.timeout(2500)
                    : undefined,
                  priority: 'low',
                }
              )
                .then(function (res) {
                  if (!res.ok) throw new Error('not_found');
                  return res.json();
                })
                .then(function (n) {
                  if (!n || !n.phone_display || !n.phone_e164) throw new Error('bad_payload');
                  try {
                    sessionStorage.setItem(cacheKey, JSON.stringify({
                      d: n.phone_display,
                      e: n.phone_e164,
                      exp: Date.now() + 600000,
                    }));
                  } catch (_) {}
                  apply({ loc: loc, phone_display: n.phone_display, phone_e164: n.phone_e164 });
                })
                .catch(function () {
                  try {
                    sessionStorage.setItem(cacheKey, JSON.stringify({
                      none: true,
                      exp: Date.now() + 600000,
                    }));
                  } catch (_) {}
                });
            } catch (_) {}
          }

          // Defer the fetch off the critical path.
          if ('requestIdleCallback' in window) {
            requestIdleCallback(lookup, { timeout: 2000 });
          } else {
            setTimeout(lookup, 0);
          }
        } catch (_) {}
      })();
    })();
} catch (e) {
  setTimeout(function () { throw e; });
}
try {
(function(){const tracking = {"ga4Id":null,"googleAdsId":null,"metaPixelId":null,"clarityId":null,"conversionLabels":{"lead_form_submit":null,"qualified_lead":null,"call_requested":null,"phone_click":null,"address_entered":null}};
const conversionConfig = {"events":[{"class":"secondary","key":"lead_form_submit","name":"Form submit","trigger":"Lead form submitted successfully","value":600},{"class":"secondary","key":"call_room_reached","name":"Call room reached","trigger":"Call room loaded successfully for the first time","value":100},{"class":"secondary","key":"call_requested","name":"Talk now","trigger":"Tapped 'Connect & talk now' INSIDE the call room","value":800},{"class":"secondary","key":"appointment_booked","name":"Callback booked","trigger":"Lead booked a specific callback slot in the call room","value":700},{"class":"secondary","key":"address_entered","name":"Address entered","trigger":"Address chosen from autocomplete, or typed and confirmed at Continue","value":80},{"class":"secondary","key":"phone_click","name":"Phone click","trigger":"tel: link tapped / clicked","value":200},{"class":"secondary","key":"call_room_click","name":"Call room click","trigger":"Tapped anything that leaves for the call room — the web-call CTA, the header phone button, or the post-submit 'Talk now' / 'Pick a time' buttons","value":5},{"class":"secondary","key":"schedule_click","name":"Slot picker opened","trigger":"Opened the callback slot picker in the call room","value":5},{"class":"diagnostic","key":"lead_form_start","name":"Form start","trigger":"First keystroke in any form field","value":50},{"class":"diagnostic","key":"contact_step","name":"Contact step","trigger":"Reached the contact step (step 2 of the lead form)","value":5},{"class":"diagnostic","key":"qualified_lead","name":"Qualified lead (diagnostic)","trigger":"Submitted lead tripped a keyword qualification signal","value":0},{"class":"diagnostic","key":"landed","name":"Landed","trigger":"First interaction on the page","value":0.1},{"class":"diagnostic","key":"scroll_25","name":"Scrolled 25%","trigger":"Scrolled past 25% of the page","value":1},{"class":"diagnostic","key":"scroll_75","name":"Scrolled 75%","trigger":"Scrolled past 75% of the page","value":3},{"class":"diagnostic","key":"cta_visible","name":"CTA visible","trigger":"Form card scrolled into view","value":5},{"class":"diagnostic","key":"phone_hover","name":"Phone hover","trigger":"Desktop hover on the phone link","value":8},{"class":"diagnostic","key":"form_focus","name":"Form focus","trigger":"A form field was focused (noisy)","value":5}],"landings":[{"bucket":"AS","categories":[{"cat":"VS","categorySlug":"as-is","messageMatch":"Sell as-is — no repairs, no cleanout, on your timeline.","route":"/sell/as-is"}],"plannerLp":"/sell/as-is"},{"bucket":"UR","categories":[{"cat":"FC","categorySlug":"foreclosure","messageMatch":"Stop foreclosure — a fast cash offer before the auction date.","route":"/sell/foreclosure"},{"cat":"PR","categorySlug":"probate","messageMatch":"Sell an inherited / probate home without the hassle or repairs.","route":"/sell/probate"},{"cat":"DV","categorySlug":"divorce","messageMatch":"Sell the marital home fast and split the proceeds cleanly.","route":"/sell/divorce"}],"plannerLp":"/sell/foreclosure"},{"bucket":"GN","categories":[{"cat":"WH","categorySlug":"cash","messageMatch":"We buy houses for cash — close on the date you choose.","route":"/sell/cash"},{"cat":"TL","categorySlug":"landlord","messageMatch":"Sell your rental, tenants and all — no turnover, no listing.","route":"/sell/landlord"}],"plannerLp":"/sell/cash"}],"tierFactors":{"High":1.4,"Low":0.7,"Mid":1},"version":1};
const leadValueMap = {"lead_form_submit":600,"call_room_reached":100,"call_requested":800,"appointment_booked":700,"address_entered":80,"phone_click":200,"call_room_click":5,"schedule_click":5,"lead_form_start":50,"contact_step":5,"qualified_lead":0,"landed":0.1,"scroll_25":1,"scroll_75":3,"cta_visible":5,"phone_hover":8,"form_focus":5};
const prodDomain = "eqall.net";
const brandId = "testing";
const autocompleteHosts = [];

        // Split tracking boot. The GOOGLE tag (one gtag.js + GA4 + Ads configs)
        // loads at idle on every page view: Google Ads' tag checker fetches the
        // landing page, never interacts, and gives up well before the 10s
        // fallback — with the Ads config behind the interaction gate it reported
        // every landing page as "not tagged" (account diagnostic, 2026-08).
        // Everything else (Meta, Clarity, the micro-conversion ladder) still
        // waits for first user interaction or the 10s fallback — no crawler
        // watches those, and keeping them off the critical path is what the
        // deferral buys in INP/Lighthouse.
        (function () {
          // Production-host gate: third-party tags (GA4 / Ads / Meta / Clarity)
          // only ever load on the brand's real domain. Localhost, *.pages.dev
          // previews, and any staging host keep the full LOCAL plumbing — gtag
          // stub, __fireConversion, __leadEvents lead trail — so form flows stay
          // testable end-to-end, but no tag script is injected and no Ads
          // send_to can fire: clicking around an approved preview can never
          // record a real conversion. Deliberately no override — verify tags on
          // the live domain instead (without an ad click nothing counts anyway).
          // A brand JSON without `domain` fails OPEN (old behavior).
          //
          // A walk-sheet test visit counts as off-prod for the whole tab: the
          // app's walk sheet opens this page with `#walk-test…` in the fragment
          // (lead-form.js reads it, fills the form and marks the tab), and a
          // tester's form must never reach Google Ads as a conversion or GA4 as
          // a visitor. Only this block reads it: the number-impression beacon
          // above keeps running, because the walk tests calls to that number.
          var walkTest = /^#walk-test(&|$)/.test(location.hash || '');
          try {
            if (walkTest) sessionStorage.setItem('op_walk_test', '1');
            else walkTest = sessionStorage.getItem('op_walk_test') === '1';
          } catch (_) {}
          var isProdHost = !walkTest && (!prodDomain ||
            location.hostname === prodDomain ||
            location.hostname.slice(-(prodDomain.length + 1)) === '.' + prodDomain);
          var fired = false;
          var ga4Booted = false;
          var adsBooted = false;
          var events = ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'];
          function defer(fn) {
            if ('requestIdleCallback' in window) {
              requestIdleCallback(fn, { timeout: 2000 });
            } else {
              setTimeout(fn, 0);
            }
          }
          function fire() {
            if (fired) return;
            fired = true;
            events.forEach(function (e) {
              window.removeEventListener(e, fire, { passive: true });
            });
            clearTimeout(fallback);
            // JIT preconnect: warm the sockets to the 3P origins the instant an
            // interaction commits us to loading them, so the TLS handshake overlaps
            // the (deferred) script fetch instead of serializing after it. Kept out
            // of the static <head> so a hard bounce never opens these connections.
            injectPreconnect();
            // INP: get OFF the triggering gesture. loadTrackers builds gtag/pixels
            // synchronously; running it inline would block the CTA click from
            // painting. Defer to the next idle tick so the gesture commits first.
            defer(loadTrackers);
          }
          function inject(src) {
            var s = document.createElement('script');
            s.async = true;
            s.src = src;
            document.head.appendChild(s);
            return s;
          }
          function injectPreconnect() {
            // Off-prod only the FUNCTIONAL hosts get warmed (address
            // autocomplete, Turnstile) — the tracking origins are never
            // contacted at all. Warming the autocomplete origin keeps the first
            // keystroke off a cold handshake. (The legacy Google era needed a
            // SECOND entry, maps.googleapis.com, for the SDK download itself —
            // that one is gone for good: both providers are now plain REST.)
            //
            // `autocompleteHosts` is built from the KEYS a brand carries, so a
            // brand running the split warms both and a brand with neither warms
            // nothing. Preconnecting an origin lead-form.js will never call is
            // pure waste on every page view, and brands with no key at all are
            // the default rather than the exception. It is deliberately NOT
            // narrowed to the provider this tab drew: that draw happens inside
            // lead-form.js, well after this runs, and warming one extra socket
            // on a split brand is cheaper than warming the wrong one.
            var hosts = isProdHost
              ? [
                  'https://www.googletagmanager.com',
                  'https://www.clarity.ms',
                  'https://connect.facebook.net',
                  // Turnstile challenge host — the lead form loads its script on this
                  // same first-interaction gate, so warm the socket alongside the rest.
                  'https://challenges.cloudflare.com',
                ]
              : ['https://challenges.cloudflare.com'];
            hosts = hosts.concat(autocompleteHosts || []);
            for (var i = 0; i < hosts.length; i++) {
              var l = document.createElement('link');
              l.rel = 'preconnect';
              l.href = hosts[i];
              document.head.appendChild(l);
            }
          }

          // Idempotent gtag base: dataLayer + gtag stub + the per-lead breadcrumb
          // mirror + the shared conversion helper. Safe to call from BOTH the idle
          // page_view path and the interaction path — it wires itself exactly once.
          function bootGtagBase() {
            if (window.__gtagBooted) return;
            window.__gtagBooted = true;
            window.dataLayer = window.dataLayer || [];
            function gtag() { window.dataLayer.push(arguments); }
            window.gtag = gtag;

            // Off-prod, announce the gate once and echo every event to the
            // console — the dev/preview substitute for the network tab, so the
            // label wiring is testable without anything reaching Google.
            if (!isProdHost) {
              var labelCount = 0;
              for (var lk in (tracking.conversionLabels || {})) {
                if (tracking.conversionLabels[lk]) labelCount++;
              }
              console.info(
                '[tracking:dev] host "' + location.hostname + '" is not production' +
                ' ("' + (prodDomain || 'no domain in brand') + '") — tags NOT loaded;' +
                ' events are logged below instead of sent.' +
                ' Configured: GA4=' + (tracking.ga4Id || 'none') +
                ', Ads=' + (tracking.googleAdsId || 'none') +
                ', conversion labels=' + labelCount
              );
            }

            // Per-lead micro-conversion trail: mirror each gtag *event* into a small
            // buffer the lead form includes in its POST, so the CRM sees THIS lead's
            // funnel (lead-scoped — GA4 still owns aggregate/anonymous funnel analytics).
            window.__leadEvents = window.__leadEvents || [];
            // The ranker's conversion ladder (event defs + $ values), so the lead
            // form's POST and any conversion firing can value each event.
            window.__leadsConversionConfig = conversionConfig || null;
            (function () {
              var raw = window.gtag;
              window.gtag = function (cmd, name) {
                if (cmd === 'event' && typeof name === 'string') {
                  try {
                    var v = (leadValueMap && leadValueMap[name]) || 0;
                    window.__leadEvents.push({ k: name, t: Date.now(), v: v });
                  } catch (e) {}
                  // Dev echo: what GA4 would have received (dataLayer pushes go
                  // nowhere off-prod since gtag.js is never injected).
                  if (!isProdHost) {
                    try {
                      console.debug('[tracking:dev] gtag event (not sent):', name, arguments[2] || {});
                    } catch (e) {}
                  }
                }
                return raw.apply(this, arguments);
              };
            })();

            // Shared conversion helper: fire the GA4 event AND, when a Google
            // Ads id + a per-event conversion label both exist, also fire the
            // Ads `conversion` event (send_to = AW-<id>/<label>). With
            // googleAdsId or the label null (today's default) this is a plain
            // gtag('event',…) — byte-for-byte the old behavior. The Ads ping is
            // deduped per event name so a double-submit can't double-count the
            // primary (lead_form_submit) conversion.
            var convFired = {};
            window.__fireConversion = function (name, params) {
              params = params || {};
              // Authoritative $ value: when the caller omits `value`, default it
              // from leadValueMap[name] (built from conversion-config.json — the
              // single source of truth for the event ladder). Callers pass only
              // { currency, transaction_id } and inherit the config value, so a
              // hardcoded literal can never drift from the ranker config. An
              // explicit caller value (e.g. setupMicroConversions' fallback) still
              // wins. Applied BEFORE the GA4 event so both pings carry it.
              if (params.value == null && leadValueMap && leadValueMap[name] != null) {
                params.value = leadValueMap[name];
              }
              if (window.gtag) window.gtag('event', name, params);
              // Label is computed on EVERY host so the dev echo below shows the
              // real would-be send_to — but the actual Ads ping only ever fires
              // on the production host (belt-and-braces with the loader gate).
              var label = tracking.googleAdsId &&
                tracking.conversionLabels &&
                tracking.conversionLabels[name];
              if (window.gtag && label && !convFired[name]) {
                convFired[name] = true;
                var conv = {
                  send_to: tracking.googleAdsId + '/' + label,
                  currency: 'USD',
                };
                if (params.value != null) conv.value = params.value;
                if (params.transaction_id) conv.transaction_id = params.transaction_id;
                if (isProdHost) {
                  window.gtag('event', 'conversion', conv);
                } else {
                  console.info('[tracking:dev] Ads CONVERSION (not sent):', name, conv);
                }
              } else if (!isProdHost && tracking.googleAdsId && !label) {
                console.info('[tracking:dev] event "' + name + '" has no Ads label — GA4-only');
              }
              // …and keep our own copy. Everything above reports to Google and
              // is then only readable from inside the Ads UI; this is the same
              // moment banked in OUR database, which is what makes the Leads ▸
              // Funnel page answerable without opening Google Ads at all.
              bankEvent(name, params);
            };
          }

          // ── Funnel events → our own database ──────────────────────────────
          //
          // Batched sibling of the number-impression beacon. It exists because
          // the pixels above are write-only from our side: GA4 and Ads own the
          // numbers, in aggregate, on Google's clock. A row of our own is what
          // lets the funnel page show in-page drop-off (landed → scrolled → CTA
          // → form → address → submit) and — unlike the impression beacon,
          // which fires ONLY when a Google click id is present — it also sees
          // ORGANIC visitors, who are otherwise invisible to us entirely.
          //
          // RECORD-ONLY. Phoenix banks these and never uploads them: Google Ads
          // de-dupes by Order ID only within a single conversion action, so
          // re-delivering a pixel event on the import rail would double-count
          // it with nothing able to undo it.
          //
          // Cheap by construction. Events buffer and flush ONCE per visit
          // (debounced, plus a guaranteed flush on pagehide) rather than one
          // request per rung, and a rung already reported by this tab is never
          // re-sent — a five-page browse costs one or two requests, not thirty.
          var bankBuf = [];
          var bankTimer = null;
          var BANK_SENT_KEY = 'lp_events_sent';

          function bankSeen(name) {
            try {
              var sent = JSON.parse(sessionStorage.getItem(BANK_SENT_KEY) || '[]');
              if (!Array.isArray(sent)) sent = [];
              if (sent.indexOf(name) !== -1) return true;
              sent.push(name);
              // Bounded: the catalog is ~13 rungs, so this can't grow.
              sessionStorage.setItem(BANK_SENT_KEY, JSON.stringify(sent.slice(-40)));
              return false;
            } catch (_) {
              // sessionStorage blocked — send it. The server collapses on
              // (session_key, event) too, and an unkeyed row counts once.
              return false;
            }
          }

          // Same per-tab id the number-impression beacon uses, so both rails
          // agree on what one visit is. Not a user id: it dies with the tab and
          // is never joined to a person.
          function bankSessionKey() {
            try {
              var k = sessionStorage.getItem('imp_session');
              if (!k) {
                k = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
                sessionStorage.setItem('imp_session', k);
              }
              return k;
            } catch (_) { return null; }
          }

          // Per-BROWSER id, in localStorage so it survives the tab closing.
          // This is the one thing about a visitor we keep, and it exists so a
          // person who reads on Tuesday and calls on Friday is one person on
          // their deal instead of two strangers.
          //
          // localStorage rather than a cookie: it is never sent as a header, so
          // it cannot leak onto an unrelated request, and it is same-origin by
          // construction. It is minted here, goes only to our own origin, and
          // is joined to nothing outside our system — see the privacy policy's
          // cookies clause, which describes exactly this.
          //
          // A browser with storage blocked cannot keep one, so it gets a code
          // for THIS page only (`window.__lpVisitCode`, the same one the call
          // room link carries; see `visitorKey()` above). It used to get none,
          // on the reasoning that a key which changes on every view looks like
          // a stream of first-time visitors. That mattered while a pageview
          // minted a deal; it does not now (a visitor is an arrival, not a
          // deal), and what the code buys is that the call room's door can tell
          // this seller's link from a crawler's, which carries nothing. It is
          // reported here too so the door finds the code already known.
          function bankVisitorKey() {
            try {
              var k = localStorage.getItem('lp_visitor') || window.__lpVisitCode;
              if (!k) k = (Date.now().toString(36) + Math.random().toString(36).slice(2, 12));
              window.__lpVisitCode = k;
              localStorage.setItem('lp_visitor', k);
              return k;
            } catch (_) {
              if (!window.__lpVisitCode) {
                window.__lpVisitCode =
                  (Date.now().toString(36) + Math.random().toString(36).slice(2, 12));
              }
              return window.__lpVisitCode;
            }
          }

          // Where this visit came from: the HOST of the page that linked here
          // ("www.google.com"), '' when the browser names none (a typed
          // address, a bookmark, an app, and most crawlers), null when it
          // cannot be read. The attribution capture above only runs when the
          // URL carries an ad parameter, so without this an unpaid search
          // visitor arrives looking exactly like nobody.
          //
          // Host only: the rest of a referring address is somebody else's page
          // and nothing here needs it. Kept for the tab, because every page
          // after the first is referred by this site, and read once at load
          // for the same reason.
          function bankReferrer() {
            try {
              var held = sessionStorage.getItem('lp_referrer');
              if (held !== null) return held;
              var host = '';
              try {
                host = document.referrer ? new URL(document.referrer).hostname : '';
              } catch (_) {}
              if (host === location.hostname) host = '';
              sessionStorage.setItem('lp_referrer', host);
              return host;
            } catch (_) { return null; }
          }
          bankReferrer();

          // Moments worth knowing about WHILE they are happening, rather than
          // whenever the visitor happens to leave. Everything here is either an
          // arrival or a decision; the noisy diagnostics (scroll depth, CTA
          // visibility, hover) stay on the batch, because nobody needs those in
          // real time and sending each one would turn a two-request visit into
          // a dozen.
          var LIVE_EVENTS = {
            landed: 1,
            lead_form_start: 1,
            address_entered: 1,
            contact_step: 1,
            phone_click: 1,
            call_room_click: 1,
            offer_click: 1,
            contact_entered: 1,
            lead_form_submit: 1,
          };

          function bankEvent(name, params) {
            try {
              var live = LIVE_EVENTS[name] === 1;

              // A rung this tab already reported. The funnel rail collapses it
              // server-side anyway, so re-sending buys nothing THERE — but the
              // activity rail wants the second occurrence, because "they came
              // back and typed a different address" is the thing a deal's
              // timeline exists to show.
              //
              // The split is by kind, not by table: arrivals and decisions
              // (LIVE_EVENTS) are worth a repeat, the noisy diagnostics
              // — scroll depth, CTA visibility, hover — are not, and letting
              // those repeat would turn a five-page browse into thirty rows
              // nobody reads. Peter's rule, 2026-08-19: record what they
              // ENTERED and what they DECIDED, not every twitch.
              var seen = bankSeen(name);
              if (seen && !live) return;

              bankBuf.push({
                k: name,
                t: Date.now(),
                // The form's per-submission id, already threaded through as the
                // gtag transaction_id — this is the join back to
                // lead_submissions, at no extra plumbing cost.
                lead_id: (params && params.transaction_id) || undefined,
                path: location.pathname,
                // Detail for the activity rail only; the funnel rail ignores
                // it. `r` marks a repeat so a reader can tell "arrived" from
                // "came back" without diffing timestamps.
                d: seen ? { r: 1 } : undefined,
              });

              if (bankTimer) clearTimeout(bankTimer);

              // An arrival or a decision goes NOW. The batch exists so a visit
              // costs one or two requests instead of thirty, and that is still
              // right for the diagnostics — but it also meant the server heard
              // about a visitor only once they had already left, because the
              // guaranteed flush is on pagehide. An operator watching a deal
              // should see them arrive while they are still on the page.
              //
              // Still a flush rather than a per-event send: a burst of live
              // events within the same tick (landed + lead_form_start) leaves
              // as one request, and anything already buffered rides along.
              bankTimer = setTimeout(bankFlush, live ? 0 : 4000);
            } catch (_) {}
          }

          // ── Address-autocomplete provider stats ───────────────────────────
          //
          // lead-form.js publishes a LIVE counter object on window.__acStats
          // when a provider is serving this visit (see its provider block).
          // It rides this same flush rather than getting a beacon of its own:
          // the batch already carries the session key, the brand, the path and
          // the attribution touch that a provider row needs to be worth
          // anything, and a visit that touched the address field is exactly the
          // visit that is flushing here anyway.
          //
          // Sent WHOLE each time rather than as a delta, because the server
          // upserts on the session key and a later flush is simply a better
          // reading of the same visit. That also makes a lost flush cost
          // precision instead of correctness.
          function acSnapshot() {
            try {
              var s = window.__acStats;
              // No provider drawn = no key configured = nothing to compare.
              if (!s || !s.provider) return null;
              // Nothing happened yet: a visit that never touched the address
              // field says nothing about either provider, and banking it would
              // dilute every rate below with rows that were never at risk.
              if (!s.keystrokes) return null;
              return {
                provider: s.provider,
                requests: s.requests,
                errors: s.errors,
                empty: s.empty,
                suggestions: s.suggestions,
                keystrokes: s.keystrokes,
                picked: !!s.picked,
                picked_index: s.picked_index,
                manual: !!s.manual,
                first_paint_ms: s.first_paint_ms,
                time_to_commit_ms: s.time_to_commit_ms,
                latency_total_ms: s.latency_total_ms,
                latency_max_ms: s.latency_max_ms,
              };
            } catch (_) {
              return null;
            }
          }

          function bankFlush() {
            if (bankTimer) { clearTimeout(bankTimer); bankTimer = null; }
            var autocomplete = acSnapshot();
            // A visit that typed an address but reached no new funnel rung
            // still has something to report — the abandoners are half of what
            // the provider comparison is measuring, so an empty event batch is
            // no longer reason enough to stay silent.
            if (!bankBuf.length && !autocomplete) return;
            var batch = bankBuf;
            bankBuf = [];
            try {
              var first = null, latest = null;
              try {
                first = JSON.parse(localStorage.getItem('attribution_first') || 'null');
                latest = JSON.parse(localStorage.getItem('attribution_latest') || 'null');
              } catch (_) {}

              var loc = null;
              try { loc = sessionStorage.getItem('loc_ctx'); } catch (_) {}
              if (!loc) loc = document.documentElement.dataset.locDefault || null;

              var body = {
                events: batch,
                session_key: bankSessionKey(),
                // Per-browser, survives the tab. A browser with storage
                // blocked sends a code that lasts only for this page.
                visitor_key: bankVisitorKey(),
                loc: loc,
                identity: { brand: brandId },
                attribution: { first: first, latest: latest },
                path: location.pathname,
              };
              // Rides in the attribution map because the server keeps that map
              // whole on the arrival. Left out when it could not be read, so
              // "came from nowhere" ('') and "we do not know" stay different.
              var referrer = bankReferrer();
              if (referrer !== null) body.attribution.referrer = referrer;
              if (autocomplete) body.autocomplete = autocomplete;

              // Same production gate as the tags above: a preview deploy must
              // not put visits into the real funnel counts. Off-prod the batch
              // is echoed instead, so the wiring stays testable.
              if (!isProdHost) {
                console.debug('[tracking:dev] funnel events (not sent):', batch.map(function (e) { return e.k; }));
                if (autocomplete) {
                  console.debug('[tracking:dev] autocomplete stats (not sent):', autocomplete);
                }
                return;
              }

              fetch('/api/landing-event', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
                // Survives the teardown this most often runs inside — the
                // pagehide flush is the one that carries a bouncing visit.
                keepalive: true,
              }).catch(function () {});
            } catch (_) {}
          }

          // The flush that matters: a visitor who reads and leaves never hits
          // the debounce, and their bounce is exactly the funnel shape worth
          // knowing about.
          window.addEventListener('pagehide', bankFlush);
          document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'hidden') bankFlush();
          });

          // Load + configure the Google tag exactly once per destination. GA4's
          // gtag('config') emits a page_view by default, so that call is also
          // what sends the initial page_view. The Ads config is the page ping
          // Google's untagged-page checker looks for — it must run here, on the
          // idle path, not behind the interaction gate. One gtag.js download
          // serves both destinations; each config has its own guard so the
          // interaction path re-calling this never double-fires either.
          function bootGoogleTag() {
            if (!isProdHost) return;
            if (!ga4Booted && tracking.ga4Id) {
              ga4Booted = true;
              bootGtagBase();
              inject('https://www.googletagmanager.com/gtag/js?id=' + tracking.ga4Id);
              window.gtag('js', new Date());
              window.gtag('config', tracking.ga4Id);
            }
            if (!adsBooted && tracking.googleAdsId) {
              adsBooted = true;
              bootGtagBase();
              if (!tracking.ga4Id) {
                inject('https://www.googletagmanager.com/gtag/js?id=' + tracking.googleAdsId);
                window.gtag('js', new Date());
              }
              window.gtag('config', tracking.googleAdsId);
            }
          }

          function loadTrackers() {
            bootGtagBase();
            // Off-prod: local plumbing + the micro-conversion ladder still run
            // (they feed the per-lead events trail the form POSTs), but no 3P
            // tag ever loads — dataLayer pushes go nowhere without gtag.js.
            if (!isProdHost) {
              setupMicroConversions();
              return;
            }
            // The Google tag is usually already up from the idle boot; the
            // per-destination guards make this a no-op then (no duplicate
            // page_view, no duplicate Ads page ping). It still matters on the
            // rare interaction that beats requestIdleCallback.
            bootGoogleTag();
            if (tracking.metaPixelId) {
              !(function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                  n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
                t = b.createElement(e); t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
              })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
              window.fbq('init', tracking.metaPixelId);
              window.fbq('track', 'PageView');
            }
            if (tracking.clarityId) {
              // Microsoft Clarity — session recordings + heatmaps.
              // Inline loader from clarity.microsoft.com docs, parameterized.
              (function (c, l, a, r, i, t, y) {
                c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
                t = l.createElement(r); t.async = 1;
                t.src = 'https://www.clarity.ms/tag/' + i;
                y = l.getElementsByTagName(r)[0];
                y.parentNode.insertBefore(t, y);
              })(window, document, 'clarity', 'script', tracking.clarityId);
            }
            setupMicroConversions();
          }

          // Stacked micro-conversion ladder. Each event fires at most once per
          // PAGE LOAD — not once per session. The dedupe is `fired` below, a
          // plain closure variable, and loadTrackers runs once per document, so
          // a visitor who moves from the metro landing page to /contact and back
          // reports landed / scroll_25 / scroll_75 / cta_visible again each time.
          // Read GA4 counts for those four accordingly: they measure pages
          // engaged, not visitors. (Nothing here persists to sessionStorage; if
          // true once-per-session is ever wanted, that is the change to make.)
          // This is also why they stay SECONDARY and must not be marked as
          // Conversions in Ads — a multi-page visit would inflate them.
          //
          // Values are calibrated to a ~$75k typical deal profit
          // (25% margin on a ~$300k home) × ~1% form→close rate × 0.75 safety
          // = ~$560 expected lead value, rounded up to $600 for the form
          // submit. Higher-funnel events are scaled down from that anchor.
          //
          // PRIMARY (mark as Conversion in Google Ads, used for bidding):
          //   lead_form_start   $50    first keystroke in any field
          //   address_entered   $80    address committed (in LeadFormScript)
          //   phone_click       $200   tel: link clicked
          //   lead_form_submit  $600   form submitted successfully
          //
          // SECONDARY (fire as events for GA4 / Clarity diagnostics, but DO
          // NOT mark as Conversions in Google Ads — they're too easy to fire
          // and would teach the bidder to chase bounce-stragglers):
          //   landed            $0.10  first interaction
          //   scroll_25         $1     scrolled past 25%
          //   scroll_75         $3     scrolled past 75%
          //   cta_visible       $5     form card in viewport
          //   phone_hover       $8     desktop hover on tel: link
          //   form_focus        $5     field focused (demoted — most focus
          //                            events don't lead to typing)
          function setupMicroConversions() {
            var fired = {};
            function fire(name, value) {
              if (fired[name]) return;
              fired[name] = true;
              // Single source of firing values: leadValueMap (built from
              // conversion-config.json) is authoritative; the inline arg is only
              // a fallback for an event the ranker config doesn't define.
              var v = (leadValueMap && leadValueMap[name] != null)
                ? leadValueMap[name]
                : value;
              // Route through the shared helper so conversion-labeled events
              // (e.g. phone_click) also fire the Ads conversion; unlabeled
              // events stay plain GA4 events.
              window.__fireConversion(name, { value: v, currency: 'USD' });
            }

            // Secondary: landed — fires immediately since gtag just initialized
            fire('landed', 0.1);

            // Secondary: scroll_25 + scroll_75 — passive scroll listener
            function checkScroll() {
              var doc = document.documentElement;
              var max = Math.max(1, doc.scrollHeight - window.innerHeight);
              var pct = (window.scrollY || doc.scrollTop) / max;
              if (pct >= 0.25) fire('scroll_25', 1);
              if (pct >= 0.75) {
                fire('scroll_75', 3);
                window.removeEventListener('scroll', checkScroll);
              }
            }
            window.addEventListener('scroll', checkScroll, { passive: true });
            checkScroll(); // in case the user is already past 25% on load

            // Secondary: cta_visible — IntersectionObserver on the form card
            var formCard = document.getElementById('offer');
            if (formCard && 'IntersectionObserver' in window) {
              var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                  if (e.isIntersecting) {
                    fire('cta_visible', 5);
                    io.disconnect();
                  }
                });
              }, { threshold: 0.5 });
              io.observe(formCard);
            }

            // Secondary: phone_hover (desktop) + PRIMARY: phone_click (any device)
            var phoneLinks = document.querySelectorAll('a[href^="tel:"]');
            for (var i = 0; i < phoneLinks.length; i++) {
              phoneLinks[i].addEventListener('mouseenter', function () {
                fire('phone_hover', 8);
              }, { once: true });
              phoneLinks[i].addEventListener('click', function () {
                fire('phone_click', 200);
              });
            }

            // How far a visitor got, for the deal their visit is filed on
            // (`Operaitor.VisitorActivity.DealLink` reads these two names).
            // Banked in our own database only: neither is a conversion, so
            // neither goes to GA4 or Ads, and neither carries what was typed.
            //
            // offer_click: any cash offer button. They all point at the form
            // (`#offer`): the header's, the hero's, the band's and the
            // footer's. Delegated, because the header swaps its button in.
            document.addEventListener('click', function (e) {
              var a = e.target && e.target.closest &&
                e.target.closest('[data-offer-focus], a[href$="#offer"]');
              if (a) bankEvent('offer_click');
            });

            // contact_entered: a phone number or an email left in the form
            // that looks like one. Read on `change`, so a half-typed value
            // the visitor is still editing says nothing.
            document.addEventListener('change', function (e) {
              var el = e.target;
              if (!el || !el.closest || !el.closest('#lead-form')) return;
              var value = String(el.value || '');
              var isPhone = el.type === 'tel' || el.name === 'phone';
              var isEmail = el.type === 'email' || el.name === 'email';
              if (
                (isPhone && value.replace(/\D/g, '').length >= 10) ||
                (isEmail && /^\S+@\S+\.\S+$/.test(value.trim()))
              ) {
                bankEvent('contact_entered');
              }
            });

            // Secondary: form_focus + PRIMARY: lead_form_start.
            // form_focus fires for tab-throughs and accidental clicks (high
            // noise). lead_form_start fires only when the user actually types
            // a character — ~3× more predictive of submit.
            var formInputs = document.querySelectorAll('#lead-form input, #lead-form textarea');
            function onFirstInput() {
              fire('lead_form_start', 50);
              for (var k = 0; k < formInputs.length; k++) {
                formInputs[k].removeEventListener('input', onFirstInput);
              }
            }
            for (var j = 0; j < formInputs.length; j++) {
              formInputs[j].addEventListener('focus', function () {
                fire('form_focus', 5);
              }, { once: true });
              formInputs[j].addEventListener('input', onFirstInput, { once: true });
            }

            // PRIMARY: address_entered — fired by LeadFormScript's
            // commitAddress when the user picks a suggestion (or types a full
            // address and continues). Strong intent signal in motivated-seller.
            //
            // PRIMARY: lead_form_submit — fired by LeadFormScript on success.
          }
          events.forEach(function (e) {
            window.addEventListener(e, fire, { once: true, passive: true });
          });
          var fallback = setTimeout(fire, 10000);

          // Google tag at load, on idle, INDEPENDENT of the interaction gate —
          // so hard bounces (which never interact) still count in GA4 (the CVR
          // denominator) and Google Ads' tag checker sees its config on every
          // landing page instead of reporting the site untagged. These are the
          // ONLY 3P requests allowed before interaction; Meta/Clarity + the
          // micro-conversion ladder all stay deferred behind fire().
          // Order-independent with fire(): whichever runs first boots the tag,
          // and the per-destination guards block a second config.
          function idleBootGoogleTag() {
            try { bootGoogleTag(); } catch (_) {}
          }
          if ('requestIdleCallback' in window) {
            requestIdleCallback(idleBootGoogleTag, { timeout: 3000 });
          } else {
            setTimeout(idleBootGoogleTag, 0);
          }
        })();
    })();
} catch (e) {
  setTimeout(function () { throw e; });
}